<template>
  <div class="mx-auto mt-[100px] max-w-[1140px] px-[25px] xl:px-0">
    <div class="text-center">
      <div
        id="text_email_integrations"
        class="text-xs font-bold tracking-wide text-[#2D8CFF]"
      >
        SETTINGS
      </div>

      <h2
        class="px-auto mt-[20px] text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
      >
        Offer programs that break the internet.
      </h2>
    </div>

    <div class="lg:flex justify-between mx-auto lg:gap-[50px] mt-[90px]">
      <!-- BLUE BORDER CARD -->

      <div
        class="bg-white shadow-xl rounded-r-[5px] border-l-[4px] border-[#49CCF9] lg:h-[620px] lg:w-[545px] px-[20px] lg:px-[45px] pb-[25px]"
      >
        <video
          class="lg:w-[400px] mx-auto -m-[30px] rounded-[10px] lg:rounded-[20px] shadow-2xl"
          id=""
          loop
          muted
          autoplay
          playsinline
        >
          <source
            :src="$filters.media_path('/videos/checkout-page-com.mp4')"
            type="video/mp4"
          />
        </video>

        <h2
          class="px-auto text-left top-full mt-[50px] text-[35px] font-bold text-[#292d34]"
        >
          Monetize Your Course and Programs.
        </h2>

        <div class="flex mt-[30px]">
          <img
            loading="lazy"
            class="pr-[15px]"
            :src="
              $filters.media_path('/images/turqoise-checkmark-button-icon.svg')
            "
            alt="Video upload module to add titles, descriptions, and thumbnails."
          />

          <p class="px-auto top-full my-auto text-sm text-[#292d34]">
            Unlimited Courses with one login.
          </p>
        </div>
        <div class="flex mt-[25px]">
          <img
            loading="lazy"
            class="pr-[15px]"
            :src="
              $filters.media_path('/images/turqoise-checkmark-button-icon.svg')
            "
            alt="Video upload module to add titles, descriptions, and thumbnails."
          />

          <p class="px-auto top-full my-auto text-sm text-[#292d34]">
            Checkout Cart Pages or 3rd Party Cart Integration.
          </p>
        </div>
        <div class="flex mt-[25px]">
          <img
            loading="lazy"
            class="pr-[15px]"
            :src="
              $filters.media_path('/images/turqoise-checkmark-button-icon.svg')
            "
            alt="Video upload module to add titles, descriptions, and thumbnails."
          />

          <p class="px-auto top-full my-auto text-sm text-[#292d34]">
            Paywall and Upsell additional courses or forms of content.
          </p>
        </div>
      </div>

      <!-- YELLOW BORDER CARD             -->

      <div
        class="bg-white shadow-xl mt-[75px] lg:mt-0 rounded-r-[5px] border-l-[4px] border-[#FFC800] lg:h-[620px] lg:w-[545px] px-[20px] lg:px-[45px] pb-[25px]"
      >
        <video
          class="lg:w-[457px] mx-auto -m-[30px] rounded-[10px] lg:rounded-[20px] shadow-2xl"
          id="home_video"
          loop
          muted
          autoplay
          playsinline
        >
          <source
            :src="
              $filters.media_path(
                '/videos/member-sessions-for-tracking-customers-com.mp4'
              )
            "
            type="video/mp4"
          />
        </video>

        <h2
          class="px-auto text-left top-full mt-[50px] text-[35px] font-bold text-[#292d34]"
        >
          Capture and Analyze Member Data.
        </h2>

        <div class="flex mt-[30px]">
          <img
            loading="lazy"
            class="pr-[15px]"
            :src="
              $filters.media_path('/images/yellow-checkmark-button-icon.svg')
            "
            alt="Video upload module to add titles, descriptions, and thumbnails."
          />

          <p class="px-auto top-full my-auto text-sm text-[#292d34]">
            Track Member Progess.
          </p>
        </div>
        <div class="flex mt-[25px]">
          <img
            loading="lazy"
            class="pr-[15px]"
            :src="
              $filters.media_path('/images/yellow-checkmark-button-icon.svg')
            "
            alt="Video upload module to add titles, descriptions, and thumbnails."
          />

          <p class="px-auto top-full my-auto text-sm text-[#292d34]">
            Access Login Sessions including IP Addresses, etc.
          </p>
        </div>
        <div class="flex mt-[25px]">
          <img
            loading="lazy"
            class="pr-[15px]"
            :src="
              $filters.media_path('/images/yellow-checkmark-button-icon.svg')
            "
            alt="Video upload module to add titles, descriptions, and thumbnails."
          />

          <p class="px-auto top-full my-auto text-sm text-[#292d34]">
            Google Tag Manager & Meta/Facebook Pixel.
          </p>
        </div>
      </div>

      <!-- YELLOW CARD END  -->
    </div>
  </div>
</template>

<!-- SCRIPTS -->

<script></script>

<!-- STYLES -->

<style></style>
